import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Row, Card, CardBody, CardTitle, Input, Button } from 'reactstrap';
import Select from 'react-select';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactTable from 'react-table';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import DataTablePagination from '../../../../../../components/DatatablePagination';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import moment from 'moment';
import classnames from 'classnames';
import { AxiosAPI, getUserID } from '../../../../../../helpers/AxiosAPI';
import {
  gAPI_PropertiesSearch,
  gAPI_Groups,
} from '../../../../../../constants/APIs';
import {
  reactSelectOption,
  reactSelectOptionDiffrentProWithKeyValue,
  sortPropertyListByName,
} from '../../../../../../helpers/Utils';

const statusList = [
  { label: 'Active', value: 'Active' },
  { label: 'Live', value: 'Live' },
  { label: 'Inactive', value: 'Inactive' },
];

export default function PropertiesList({
  data,
  labels,
  timeZone,
  fromDate,
  toDate,
}) {
  moment.tz.setDefault(timeZone);
  const csvLink = useRef(null);
  const options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    showTitle: false,
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
  };
  const csvConfig = mkConfig(options);
  const [propertyData, setPropertyData] = useState(data);
  const [downloadInput, setDownloadInput] = useState('0');
  const [ApiState, setApiState] = useState('default');
  const [filterGroup, setFilterGroup] = useState([]);
  const [filterStatus, setFilterStatus] = useState([]);
  const [filterProvider, setFilterProvider] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState([]);
  const [isFiltering, setIsFiltering] = useState(false);
  const [groupsList, setGroupsList] = useState([]);
  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Groups}/${getUserID()}`,
    })
      .then((res) => {
        var grouplist = [];
        if (res.data !== null) {
          res.data.map((l) => {
            grouplist.push({
              id: l.groupId,
              name: l.name,
            });
          });
        }
        setGroupsList(grouplist);
      })
      .catch((err) => console.log('err', err));
  }, [data]);
  const downloadCurrent = () => {
    setApiState('processing');
    if (downloadInput === '0') {
      const tablePrint = propertyData.map((elem) => ({
        'Group Name': elem.groupName,
        Property: elem.name,
        Country: elem.country,
        'Live Date': elem.activationDate,
        MRR: elem.monthlyBillingAmountNZD,
      }));
      const csv = generateCsv(csvConfig)(tablePrint);
      download(csvConfig)(csv);
      setApiState('success');
    } else {
      var startDate = '';
      var endDate = moment(moment().format('YYYY-MM-DD') + ' 23:59:59')
        .utc()
        .format('YYYY-MM-DD HH:mm:ss');

      if (downloadInput === '1') {
        startDate = moment(
          moment().subtract(6, 'days').format('YYYY-MM-DD') + ' 00:00:00'
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');
      } else if (downloadInput === '2') {
        startDate = moment(
          moment().subtract(29, 'days').format('YYYY-MM-DD') + ' 00:00:00'
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');
      } else if (downloadInput === '3') {
        const today = moment();
        startDate = moment(
          moment(today).isoWeekday(1).format('YYYY-MM-DD') + ' 00:00:00'
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');

        endDate = moment(
          moment(today).isoWeekday(7).format('YYYY-MM-DD') + ' 23:59:59'
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');
      } else if (downloadInput === '4') {
        startDate = moment(
          moment().startOf('month').format('YYYY-MM-DD') + ' 00:00:00'
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');
      } else if (downloadInput === '5') {
        startDate = moment(
          moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD') +
          ' 00:00:00'
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');

        endDate = moment(
          moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD') +
          ' 23:59:59'
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss');
      } else if (downloadInput === '6') {
        startDate = moment(
          new Date().getFullYear() + '-01-01' + ' 00:00:00'
        ).format('YYYY-MM-DD HH:mm:ss');
      } else if (downloadInput === '7') {
        startDate = moment(
          new Date().getFullYear() - 1 + '-01-01' + ' 00:00:00'
        ).format('YYYY-MM-DD HH:mm:ss');
        endDate = moment(
          new Date().getFullYear() - 1 + '-12-31' + ' 00:00:00'
        ).format('YYYY-MM-DD HH:mm:ss');
      } else if (downloadInput === '8') {
        startDate = '2019-01-01';
      }

      AxiosAPI({
        method: 'get',
        url: `${gAPI_PropertiesSearch}`,
        params: {
          dateFrom: startDate,
          dateTo: endDate,
          groupid: '-1',
          status: '-1',
          provider: '-1',
        },
      }).then((res) => {
        setApiState('success');
        setPropertyData(res.data);
        const tablePrint = res.data.map((elem) => ({
          'Group Name': elem.groupName,
          Property: elem.name,
          Country: elem.country,
          'Live Date': elem.activationDate,
          MRR: elem.monthlyBillingAmountNZD,
        }));
        const csv = generateCsv(csvConfig)(tablePrint);
        download(csvConfig)(csv);
      });
    }
  };
  const handleTextChange = (e) => {
    setDownloadInput(e.target.value);
  };
  const handleChangeSelect = (value, { name }) => {
    if (name === 'statuss') {
      setSelectedStatus(value);
      var exist = [];
      value.map((e) => exist.push(e.value));
      setFilterStatus(exist);
    } else if (name === 'groupId') {
      setSelectedGroup(value);
      var exist = [];
      exist.push(value.value);
      setFilterGroup(exist);
    }
  };
  const handleFilterClick = () => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_PropertiesSearch}`,
      params: {
        dateFrom: fromDate,
        dateTo: toDate,
        groupid: filterGroup.length > 0 ? filterGroup.join('|') : '-1',
        status: filterStatus.length > 0 ? filterStatus.join('|') : '-1',
        provider: filterProvider.length > 0 ? filterProvider.join('|') : '-1',
      },
    }).then((res) => {
      setPropertyData(res.data);
      setIsFiltering(false);
    });
  };
  const Filterpopup = () => {
    return (
      isFiltering && (
        <Row>
          <Fragment>
            <Card
              style={{
                position: 'absolute',
                zIndex: '99999',
                top: '3.7rem',
                right: '12rem',
                boxShadow:
                  '0 1px 20px 20px rgb(0 0 0 / 4%), 0 1px 6px rgb(0 0 0 / 4%)',
              }}
            >
              <CardBody>
                <Colxx xxs="12" md="12" className="mb-2">
                  <Select
                    className="react-select"
                    classNamePrefix="react-select"
                    name="groupId"
                    isMulti={false}
                    value={selectedGroup}
                    onChange={handleChangeSelect}
                    options={
                      groupsList
                        ? reactSelectOption(
                          groupsList,
                          true,
                          'groupId',
                          'name',
                          'Select Group'
                        )
                        : []
                    }
                  />
                </Colxx>
                <Colxx xxs="12" md="12" className="mb-2">
                  <Select
                    isMulti={true}
                    className="react-select ticketing-select"
                    classNamePrefix="react-select"
                    name="statuss"
                    placeholder="Select Status"
                    onChange={handleChangeSelect}
                    options={statusList}
                    value={selectedStatus}
                  />
                </Colxx>
                <Colxx xxs="12" md="12" className="mb-2">
                  <Input className='input_sty'
                    type="select"
                    value={selectedProvider}
                    name="type"
                    onChange={(e) => {
                      setSelectedProvider(e.target.value);
                      setFilterProvider([e.target.value]);
                    }}
                  >
                    <option value="-1">Select</option>
                    <option value="1">Book Me Bob</option>
                    <option value="2">Aiva</option>
                    <option value="3">Phone Suite</option>
                    <option value="4">Myma</option>
                    <option value="5">Aven Hospitality</option>
                  </Input>
                </Colxx>
                <Colxx xxs="12" md="12" className="mt-3">
                  <Button
                    size="xs"
                    color="primary"
                    className="mb-2 mr-2"
                    onClick={() => handleFilterClick()}
                  >
                    <IntlMessages id="forms.submit" />
                  </Button>
                  <Button
                    size="xs"
                    color="secondary"
                    className="mb-2 mr-2 ml-2"
                    onClick={() => setIsFiltering(false)}
                  >
                    Cancel
                  </Button>
                </Colxx>
              </CardBody>
            </Card>
          </Fragment>
        </Row>
      )
    );
  };
  return (
    <Fragment>
      <Card>
        <div style={{ padding: '15px', paddingBottom: '0px' }}>
          <div className="float-left float-none-xs">
            <div className="d-inline-block">
              <h5 className="d-inline">
                <IntlMessages id="dashboards.live-properties"></IntlMessages>
              </h5>
              <span className="text-muted text-small d-block">
                <IntlMessages id="dashboards.all-properties-with"></IntlMessages>
              </span>
            </div>
          </div>
          <div className="float-right form-inline text-right">
            <Button
              size="xs"
              color="primary"
              className="mr-4"
              onClick={() => setIsFiltering(!isFiltering)}
            >
              <div className="d-flex">
                <FontAwesomeIcon icon={faFilter} className="fa mr-1 mt-1" />{' '}
                <IntlMessages id="menu.show-filter" />{' '}
                <div className="ml-1" style={{ marginTop: '2px' }}>
                  {isFiltering ? (
                    <i className="simple-icon-arrow-up p-1"></i>
                  ) : (
                    <i className="simple-icon-arrow-down p-1"></i>
                  )}
                </div>
              </div>
            </Button>
            <Input className='input_sty'
              type="select"
              value={downloadInput}
              name="type"
              onChange={(event) => handleTextChange(event)}
            >
              <option value="0">Current</option>
              <option value="1">Last 7 Days</option>
              <option value="2">Last 30 Days</option>
              <option value="3">This Week</option>
              <option value="4">This Month</option>
              <option value="5">Previous Month</option>
              <option value="6">Year to Date</option>
              <option value="7">Last Year</option>
              <option value="8">All</option>
            </Input>
            {propertyData.length > 0 && (
              <Button
                color="primary"
                onClick={downloadCurrent}
                className={`ml-2 default btn-multiple-state ${classnames({
                  'show-spinner': ApiState === 'processing',
                  'show-success': ApiState === 'success',
                  'show-fail': ApiState === 'fail',
                })}`}
              >
                <span className="spinner d-inline-block">
                  <span className="bounce1" />
                  <span className="bounce2" />
                  <span className="bounce3" />
                </span>
                <span className="icon success">
                  <i className="simple-icon-check" />
                </span>
                <span className="icon fail">
                  <i className="simple-icon-exclamation" />
                </span>
                <span className="label">  <IntlMessages id='dashboards.download' /></span>
              </Button>
            )}
          </div>
        </div>
        <CardBody>
          <ReactTable
            data={propertyData}
            columns={labels}
            defaultPageSize={5}
            filterable={true}
            showPageJump={true}
            PaginationComponent={DataTablePagination}
            showPageSizeOptions={true}
            defaultCanFilter={true}
            defaultSorted={[
              {
                id: 'activationDate',
                desc: true,
              },
            ]}
          />
        </CardBody>
      </Card>
      {Filterpopup()}
    </Fragment>
  );
}